import { gql } from '@apollo/client';

export const FILTERED_FUNDER_INTERVENTIONS = gql`
  query FilteredFunderInterventions($input: FilterArgs) {
    interventions: filteredFunderInterventions(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;
